"use client";
import { createContext, useContext } from "react";

interface DataProps {
  selectedDistrict: any;
  selectedService: any;
}

interface UserDataProps {
  name: string;
  phone: string;
  password: string;
  gender: string;
  isAgreed: boolean;
}

interface Props {
  data: DataProps;
  userData: UserDataProps;
  onChange: (type: string, key: string, value: any) => void;
  activeStep: number;
  setActiveStep: (activeStep: number) => void;
}

export const GetQuoteContext = createContext<Props>({
  data: {
    selectedDistrict: {} as any,
    selectedService: {} as any,
  },
  userData: {
    name: "",
    phone: "",
    password: "",
    gender: "",
    isAgreed: true,
  },
  onChange: (type: string, key: string, value: string) => {},
  activeStep: 0,
  setActiveStep: (activeStep: number) => {},
});

export const GetQuoteProvider = (props: Props & { children: any }) => {
  return (
    <GetQuoteContext.Provider
      value={{
        data: props.data,
        userData: props.userData,
        onChange: props.onChange,
        activeStep: props.activeStep,
        setActiveStep: props.setActiveStep,
      }}
    >
      {props.children}
    </GetQuoteContext.Provider>
  );
};

export const useGetQuote = () => {
  return useContext(GetQuoteContext);
};
